    
    import { convert } from "html-to-text";
    
    //converts integer(seconds) into the duration
    export function secondsToDuration(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return hrs > 0 ? `${hrs}:${mins}:${secs}` : `${mins}:${secs}`;
    }

    // //gets the date only from timestamp - DD:MM:YYYY
    // export function formatDate(isoString) {
    //     const date = new Date(isoString);
    //     const day = date.getDate().toString().padStart(2, '0');
    //     const month = (date.getMonth() + 1).toString().padStart(2, '0'); // months are 0-based
    //     const year = date.getFullYear();
    //     return `${day}/${month}/${year}`;
    // }



    export function formatDate(isoString) {
        const hindiMonths = [
          'जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून',
          'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'
        ];
      
        const date = new Date(isoString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthName = hindiMonths[date.getMonth()];
        const year = date.getFullYear();
      
        return `${day} ${monthName} ${year}`;
      }

    export function convertToPlainText (html)  {
        let result = "";
        try {
          result = convert(html, {
            preserveNewlines: false,
            encodeCharacters: {
              "\n": " ",
            },
            selectors: [
              {
                selector: "a",
                options: {
                  ignoreHref: true,
                },
              },
              {
                selector: "a",
                options: {
                  hideLinkHrefIfSameAsText: true,
                },
              },
              {
                selector: "img",
                format: "skip",
              },
              {
                selector: "blockquote",
                format: "inline", // Include blockquote text
                options: {
                  trimEmptyLines: true,
                  trimWhitespace: true, // Optionally trim whitespace
                  leadingLineBreaks: 0, // Optionally add leading line breaks
                  trailingLineBreaks: 0, // Optionally add trailing line breaks
                },
              },
              {
                selector: "figure",
                format: "skip",
              },
              {
                selector: "embed",
                format: "skip",
              },
              {
                selector: "iframe",
                format: "skip",
              },
              {
                selector: "video",
                format: "skip",
              },
              {
                selector: "audio",
                format: "skip",
              },
            ],
          });
       
          return result.replaceAll("\n", "");
        } catch (error) {
          console.log(error , ' error in html to text');
          
          return result;
        }
      }
      